import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Duelist, DuelistsService } from '../../services/duelists.service';

@Component({
	selector: 'app-duelists-list',
	templateUrl: './duelists-list.component.html',
	styleUrls: ['./duelists-list.component.scss'],
})
export class DuelistsListComponent implements OnInit, OnDestroy {
	duelists: Duelist[] = [];
	private _unsubscribeAll: Subject<void> = new Subject<void>();

	constructor(
		private duelistsService: DuelistsService,
		public modalController: ModalController,
		private router: Router,
	) {}

	ngOnInit() {
		this.duelistsService.duelists$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
			next: duelists => (this.duelists = duelists),
		});
	}

	ionViewWillEnter() {
		this.duelistsService.getDuelistsList().subscribe();
	}

	ngOnDestroy() {
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	/**
	 * Set the currently selected duelist for challenging and navigate to the duel create page.
	 * @param duelist The duelist that was selected
	 */
	challengeDuelist(duelist: Duelist) {
		this.duelistsService.selectedDuelist = duelist;
		this.router.navigate(['/app/duel-create']);
	}

	closeModal() {
		this.modalController.dismiss({
			dismissed: true,
		});
	}
}
